import { render, staticRenderFns } from "./BaseFilterDateWorkflow.vue?vue&type=template&id=72a03fd1&scoped=true"
import script from "./BaseFilterDateWorkflow.vue?vue&type=script&lang=js"
export * from "./BaseFilterDateWorkflow.vue?vue&type=script&lang=js"
import style0 from "./BaseFilterDateWorkflow.vue?vue&type=style&index=0&id=72a03fd1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a03fd1",
  null
  
)

export default component.exports